import moment from 'moment-timezone';

/* eslint-disable no-restricted-syntax -- ISO on purpose: compared as a string with today's date, never shown */

function addDaysToDay(day: string, days: number) {
  return moment(day, 'YYYY-MM-DD').add(days, 'days').format('YYYY-MM-DD');
}

function countDaysBetween(firstDay: string, lastDay: string) {
  return moment(lastDay, 'YYYY-MM-DD').diff(moment(firstDay, 'YYYY-MM-DD'), 'days');
}

export { addDaysToDay, countDaysBetween };
